import { Add, Refresh } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import TableLoader from "../../components/loader/tableLoader";
import CustomTable from "../../components/table/CustomTable";
import { getAssessmentHistory } from "../../redux/actions/stateFileAction";
import { getDateAndTime } from "../../utils/timeUtils";

const AutomationAssessment = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { globalLoader } = useSelector((state) => state.common);
  const { assessmentHistories } = useSelector((state) => state.stateFile);

  useEffect(() => {
    fetchData();
    //eslint-disable-next-line
  }, []);

  const fetchData = () => {
    dispatch(getAssessmentHistory());
  };

  const columns = [
    { field: "accountNumber", label: "Account number" },
    { field: "user", label: "User", align: "left" },
    { field: "region", label: "Region", align: "left" },
    { field: "terraformManaged", label: "Terraform Managed" },
    { field: "manualyCreated", label: "Manually created" },
    {
      field: "automationPercentage",
      label: "Automation percentage",
      render: (row) => `${row.automationPercentage}%`,
    },
    {
      field: "createdAt",
      label: "Created date",
      align: "left",
      render: (row) => <Box>{getDateAndTime(row?.createdAt)}</Box>,
    },
  ];

  return (
    <Box>
      {globalLoader ? (
        <TableLoader />
      ) : (
        <>
          <Box
            mb={2}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography variant="h5" gutterBottom={true}>
              Automation Assessment
            </Typography>
            <Box display="flex" sx={{ gridGap: "12px" }}>
              <Button
                variant="outlined"
                onClick={() => fetchData()}
                startIcon={<Refresh />}
              >
                Refresh
              </Button>

              <Button
                startIcon={<Add />}
                variant="contained"
                onClick={() => history.push("assessment-creation")}
              >
                Create Assessment
              </Button>
            </Box>
          </Box>
          <CustomTable columns={columns} data={assessmentHistories} />
        </>
      )}
    </Box>
  );
};

export default AutomationAssessment;
